import React from 'react';
import Button from 'components/Buttons/Button';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import Input from 'components/Form/Input2';
import { CheckIcon as Check } from '@heroicons/react/24/outline';
import 'twin.macro';
import { useTranslation } from 'react-i18next';

interface Props {
  onAdd: (name: string) => void;
}

export function AddClassroomButton(props: Props) {
  const [text, setText] = React.useState<string | undefined>(undefined);
  const { t } = useTranslation(['onboarding']);

  return (
    <>
      {text === undefined && (
        <Button outlined extralarge icon={Plus} onClick={() => setText('')}>
          {t('onboarding:classes.addCustomGrade')}
        </Button>
      )}
      {text !== undefined && (
        <div tw="flex">
          <div tw="max-w-[8rem]">
            <Input
              tw="h-11"
              autoFocus
              value={text}
              onChange={e => setText(e?.target?.value || '')}
              onBlur={() => {
                if (text === '') {
                  setText(undefined);
                  return;
                }
                props.onAdd(text);
                setText(undefined);
              }}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  if (text === '') {
                    setText(undefined);
                    return;
                  }
                  props.onAdd(text);
                  setText(undefined);
                }
              }}
            />
          </div>

          <Button
            icon={Check}
            outlined
            extralarge
            tw="ml-2"
            onClick={() => {
              if (text === '') {
                setText(undefined);
                return;
              }
              props.onAdd(text);
              setText(undefined);
            }}
          />
        </div>
      )}
    </>
  );
}
